import { Box, Stack, Typography } from "@mui/material";
import i18n from "../../i18n-config";
import { CustomButton, SvgContainer } from "../../components";
import theme from "../../theme/theme";
import { LIST } from "../../assets/icons";
import SinistreTable from "./component/SinistreTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/state";

function Sinistre() {

  const dispatch = useDispatch();

  const sinistres = useSelector((state: RootState) => Object.values(state.sinistre));

  return (
    <Box sx={{ height: "100vh", backgroundColor: "#F9F9F9" }} p={3} pt={6}>
      <Stack direction={"row"} justifyContent="space-between" mb={3}>
        <Typography fontSize={22} fontWeight="600">
          {i18n.t("list_sinistres")}
        </Typography>
        <Stack direction={"row"} spacing={2}>
          <CustomButton
            title={i18n.t("exporter_liste")}
            leftComponent={
              <SvgContainer svg={LIST} color={theme.colors.white} width={15} />
            }
            titleStyle={{ marginLeft: 1 }}
            rootStyle={{ backgroundColor: "#3D423F", height: 45 }}
          />
        </Stack>
      </Stack>
      <SinistreTable data={sinistres} />
    </Box>
  );
}

export default Sinistre;
